import { render, staticRenderFns } from "./PyamentRedirect.vue?vue&type=template&id=46b4db06&"
import script from "./PyamentRedirect.vue?vue&type=script&lang=js&"
export * from "./PyamentRedirect.vue?vue&type=script&lang=js&"
import style0 from "./PyamentRedirect.vue?vue&type=style&index=0&id=46b4db06&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports